export default __webpack_public_path__ + "static/media/0079.33f2c3ba.jpg";